import { TenantEntity } from '../TenantEntity'

export class RailwayHeadwayTail extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get headwayTail() {
    return this._data.headwayTail
  }
  set headwayTail(headwayTail) {
    this._data.headwayTail = headwayTail
  }
  get transportMethod() {
    return this._data.transportMethod
  }
  set transportMethod(transportMethod) {
    this._data.transportMethod = transportMethod
  }
  get transportCompany() {
    return this._data.transportCompany
  }
  set transportCompany(transportCompany) {
    this._data.transportCompany = transportCompany || 0
  }
  get region() {
    return this._data.region
  }
  set region(region) {
    this._data.region = region
  }
  get province() {
    return this._data.province
  }
  set province(province) {
    this._data.province = province
  }
  get city() {
    return this._data.city
  }
  set city(city) {
    this._data.city = city
  }
  get districts() {
    return this._data.districts
  }
  set districts(districts) {
    this._data.districts = districts
  }
  get address() {
    return this._data.address
  }
  set address(address) {
    this._data.address = address
  }
  get contact() {
    return this._data.contact
  }
  set contact(contact) {
    this._data.contact = contact
  }
  get telephone() {
    return this._data.telephone
  }
  set telephone(telephone) {
    this._data.telephone = telephone
  }
  get remarks() {
    return this._data.remarks
  }
  set remarks(remarks) {
    this._data.remarks = remarks
  }
  get railwayExportJobUuid() {
    return this._data.railwayExportJobUuid
  }
  set railwayExportJobUuid(railwayExportJobUuid) {
    this._data.railwayExportJobUuid = railwayExportJobUuid
  }
}
